import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/Tarun_Profile.jpg";
import Tilt from "react-parallax-tilt";
import Type from "./Type";

function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Container className="home-content">
          <Row className="align-items-center">
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hi There!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>

              <h1 className="heading-name">
                I'M
                <strong className="main-name"> Tarun Talan</strong>
              </h1>

              <div className="home-typewriter-container">
                <Type />
              </div>
            </Col>

            {/* Right column — illustration on desktop, profile pic on mobile */}
            <Col md={5} className="myAvtar">
              {/* Illustration — desktop only */}
              <img
                src="https://user-images.githubusercontent.com/74038190/229223263-cf2e4b07-2615-4f87-9c38-e37600f8381a.gif"
                alt="home pic"
                className="img-fluid home-illustration d-none d-md-block"
                style={{ maxHeight: "450px", margin: "0 auto" }}
              />

              {/* Profile pic with Tilt — mobile only, identical to About avatar */}
              <div className="home-mobile-avatar d-md-none">
                <Tilt>
                  <img
                    src={myImg}
                    className="img-fluid"
                    alt="avatar"
                    style={{
                      borderRadius: "20%",
                      width: "250px",
                      height: "250px",
                      objectFit: "cover",
                      objectPosition: "top",
                      boxShadow: "0 0 20px rgba(200, 137, 230, 0.4), 0 4px 30px rgba(0,0,0,0.3)",
                      border: "2px solid rgba(200, 137, 230, 0.3)"
                    }}
                  />
                </Tilt>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
    </section>
  );
}

export default Home;
